import styled from "styled-components";

import { darken } from "@material-ui/core";

import { User } from "src/root/models/user";

import { ASTable, ASCard } from "allegro-ui";
import allegrobotIcon from "../../assets/img/allegrobotIcon.svg";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";

type Props = {
  user: User;
};

const StyledCard = styled(ASCard)`
  /* background-color: ${(props) => props.theme.secondaryColor}; */
  display: flex;
  background: #303030;
  min-height: 650px;
  align-items: center;
  flex-direction: column;
`;

const HeaderImage = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 240px;
`;

const IconImage = styled.div`
  position: absolute;
  width: 120px;
  height: 120px;
  top: 200px;
  > img {
    width: 100%;
    display: block;
  }
`;

const Description = styled.div`
  /* position: relative; */
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  padding: 75px 16px 75px 16px;
`;

const Name = styled.div`
  padding: 5px;
  font-size: 24px;
`;
const Caption = styled.div`
  padding: 5px;
  font-size: 14px;
  color: ${darken("#fff", 0.3)};
`;

const Detail = styled.div`
  display: flex;
  /* padding: 15px 90px 15px 90px; */
  /* width: 100%; */
  font-size: 16px;
  justify-content: center;
  flex-direction: row;
`;

const StyledTable = styled(ASTable)`
  table: {
    border-spacing: 0 0px;
    border-collapse: collapse;
  }
  tr {
    border-radius: 0px;
  }
  th: {
    font-size: 16px;
  }
  td {
    width: 120px;
    border: none;
    font-size: 16px;
    padding: 0px 8px 0px 8px;
    &:first-child {
      border-radius: 0px 0 0 0px;
      /* padding-right: 8px; */
    }
    &:last-child {
      border-radius: 0 0px 0px 0;
      /* padding-left: 8px; */
    }
  }
`;

const StyledTableRow = styled(TableRow)`
  /* height: 10px; */
`;

const StyledTableCell = styled(TableCell)`
  width: 100px;
  height: 10px;
  /* background: red; */
`;

export const OEProfileCard: React.FC<Props> = (props) => {
  const { nickName, email } = props.user;
  const [birth, age, sex, account] = ["非公開", "非公開", "男", "-"];
  const headerImage =
    "data:image/jpeg;base64,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";
  const iconImage = allegrobotIcon;

  return (
    <StyledCard>
      <HeaderImage>
        <img
          style={{ width: "100%", height: "100%" }}
          src={headerImage}
          alt="header"
        />
      </HeaderImage>
      <IconImage>
        <img src={iconImage} alt="icon" />
      </IconImage>
      <Description>
        <Name>{nickName}</Name>
        <Caption>{props.user.email}</Caption>
        <Detail>
          <TableContainer component={StyledTable} kind="tertiary">
            <Table size="small">
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell align="right">誕生日</StyledTableCell>
                  <StyledTableCell align="left">{birth}</StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell align="right">年齢</StyledTableCell>
                  <StyledTableCell align="left">{age}</StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell align="right">性別</StyledTableCell>
                  <StyledTableCell align="left">{sex}</StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell align="right">アカウント</StyledTableCell>
                  <StyledTableCell align="left">
                    {props.user.userNoText}
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Detail>
      </Description>
    </StyledCard>
  );
};
